<template>
  <div>
    {{ data.priceSell }} {{ data.currencySell && data.currencySell.code }} <template v-if="data.incotermSell">({{ data.incotermSell.name }})</template>
  </div>
</template>

<script>

export default {
  props: ['data', 'index', 'column'],
}
</script>
